import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxurious%20cinema%20interior%20with%20warm%20golden%20lighting%2C%20velvet%20red%20theater%20curtains%2C%20elegant%20movie%20theater%20atmosphere%2C%20soft%20ambient%20glow%2C%20cinematic%20depth%20of%20field%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20sophisticated%20entertainment%20venue%20aesthetic&width=1920&height=800&seq=hero-bg-cinema&orientation=landscape"
        alt="丁香花影院 - 在线影院免费观看高清电影"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 tracking-wide">
          丁香花影院
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          稳定在线影院，提供网络电视、电影网站级视频点播服务，追剧平台免费看高清电影电视剧，无需缓冲
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/action"
            className="px-8 py-3 rounded-full font-semibold text-sm whitespace-nowrap cursor-pointer transition-all duration-300 hover:scale-105"
            style={{ backgroundColor: "oklch(var(--accent-500))", color: "#fff" }}
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观影
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full font-semibold text-sm text-white border border-white/30 hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">10,000+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">影视资源</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">500万+</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">活跃用户</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">99.9%</p>
            <p className="text-xs md:text-sm text-white/60 mt-1">流畅播放</p>
          </div>
        </div>
      </div>
    </section>
  );
}